export const AVATAR_SIZE = '32px';
